import { Action } from 'redux';

export const CREATE_OPTOMETRIA_NEONATOS_REQUEST = 'CREATE_OPTOMETRIA_NEONATOS_REQUEST';
export const CREATE_OPTOMETRIA_NEONATOS_SUCCESS = 'CREATE_OPTOMETRIA_NEONATOS_SUCCESS';
export const CREATE_OPTOMETRIA_NEONATOS_FAILURE = 'CREATE_OPTOMETRIA_NEONATOS_FAILURE';

export const FETCH_OPTOMETRIA_NEONATOS_REQUEST = 'FETCH_OPTOMETRIA_NEONATOS_REQUEST';
export const FETCH_OPTOMETRIA_NEONATOS_SUCCESS = 'FETCH_OPTOMETRIA_NEONATOS_SUCCESS';
export const FETCH_OPTOMETRIA_NEONATOS_FAILURE = 'FETCH_OPTOMETRIA_NEONATOS_FAILURE';

export const SET_OPTOMETRIA_NEONATOS_PAGE = 'SET_OPTOMETRIA_NEONATOS_PAGE';
export const SET_OPTOMETRIA_NEONATOS_LIMIT = 'SET_OPTOMETRIA_NEONATOS_LIMIT';

export interface CreateOptometriaNeonatosRequestAction extends Action<typeof CREATE_OPTOMETRIA_NEONATOS_REQUEST> {
  type: typeof CREATE_OPTOMETRIA_NEONATOS_REQUEST;
}

export interface CreateOptometriaNeonatosSuccessAction extends Action<typeof CREATE_OPTOMETRIA_NEONATOS_SUCCESS> {
  type: typeof CREATE_OPTOMETRIA_NEONATOS_SUCCESS;
  payload: any;
}

export interface CreateOptometriaNeonatosFailureAction extends Action<typeof CREATE_OPTOMETRIA_NEONATOS_FAILURE> {
  type: typeof CREATE_OPTOMETRIA_NEONATOS_FAILURE;
  payload: string;
}

export interface FetchOptometriaNeonatosRequestAction extends Action<typeof FETCH_OPTOMETRIA_NEONATOS_REQUEST> {
  type: typeof FETCH_OPTOMETRIA_NEONATOS_REQUEST;
}

export interface FetchOptometriaNeonatosSuccessAction extends Action<typeof FETCH_OPTOMETRIA_NEONATOS_SUCCESS> {
  type: typeof FETCH_OPTOMETRIA_NEONATOS_SUCCESS;
  payload: {
    data: any[];
    meta: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export interface FetchOptometriaNeonatosFailureAction extends Action<typeof FETCH_OPTOMETRIA_NEONATOS_FAILURE> {
  type: typeof FETCH_OPTOMETRIA_NEONATOS_FAILURE;
  payload: string;
}

export interface SetOptometriaNeonatosPageAction extends Action<typeof SET_OPTOMETRIA_NEONATOS_PAGE> {
  type: typeof SET_OPTOMETRIA_NEONATOS_PAGE;
  payload: number;
}

export interface SetOptometriaNeonatosLimitAction extends Action<typeof SET_OPTOMETRIA_NEONATOS_LIMIT> {
  type: typeof SET_OPTOMETRIA_NEONATOS_LIMIT;
  payload: number;
}

export type OptometriaNeonatosActionTypes =
  | CreateOptometriaNeonatosRequestAction
  | CreateOptometriaNeonatosSuccessAction
  | CreateOptometriaNeonatosFailureAction
  | FetchOptometriaNeonatosRequestAction
  | FetchOptometriaNeonatosSuccessAction
  | FetchOptometriaNeonatosFailureAction
  | SetOptometriaNeonatosPageAction
  | SetOptometriaNeonatosLimitAction;